<template>
  <v-card tile flat class="my-3">
    <v-list class="pa-4 grey lighten-3 text-left" dense>
      <h3>{{ question.question }}</h3>
      <v-list-item-group
        v-model="selectedItem"
        color="orange accent-4"
        @change="risposta"
      >
        <v-list-item>
          <v-list-item-icon>
            <v-avatar dark color="grey lighten-3" size="25">
              <span class="headline">A</span>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            {{ question.options[0] }}
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-avatar dark color="grey lighten-3" size="25">
              <span class="headline">B</span>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            {{ question.options[1] }}
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-icon>
            <v-avatar dark color="grey lighten-3" size="25">
              <span class="headline">C</span>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            {{ question.options[2] }}
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: "Rispostamultipla",
  data: () => ({
    selectedItem: null,
  }),
  methods: {
    risposta() {
      this.$emit("checkMultipla", {
        indice: this.ind,
        risposta: this.selectedItem,
      });
    },
  },
  props: {
    question: Object,
    ind: Number,
  },
};
</script>
